import { useCallback } from 'react'
import { useFindAutoClaimPrinter } from './useFindAutoClaimPrinter'
import { useFlowContext } from './useFlowContext'
import { useOwnershipCheckContext } from './useOwnershipCheckContext'

export const useOwnershipCheck = (currentStep: string) => {
  const { findAutoClaimPrinter } = useFindAutoClaimPrinter(currentStep)
  const flowContext = useFlowContext()
  const { claimFailureContinueBehavior } = flowContext.getOptions()
  const { hasRunOwnershipCheck, setHasRunOwnershipCheck } =
    useOwnershipCheckContext() ?? {}

  const performOwnershipCheck = useCallback(async () => {
    if (claimFailureContinueBehavior && !hasRunOwnershipCheck) {
      try {
        setHasRunOwnershipCheck?.(true)
        await findAutoClaimPrinter(true)
      } catch {
        /* do nothing */
      }
    }
  }, [
    claimFailureContinueBehavior,
    hasRunOwnershipCheck,
    setHasRunOwnershipCheck,
    findAutoClaimPrinter
  ])

  return {
    performOwnershipCheck,
    hasRunOwnershipCheck: hasRunOwnershipCheck ?? false
  }
}
